import m from 'mithril';
import app from '../app';
import vwAdyenDropin from '../components/vwAdyenDropin';
import constants from '../lib/constants';
import paymentSession from '../lib/paymentSession';
import Loading from './components/loading';
import christmasSled from '../components/vwChristmasSled';

const vwPaymentSession = {
	loading: true,
	config: {},
	hasPayment: false,
	requestDuplicatePaymentPermission: false,
	oninit: async ({ attrs }) => {
		// Initialize the payment session
		paymentSession.initSession(attrs);

		// Get and load the payment session config
		const configResult = await paymentSession.loadConfig();

		vwPaymentSession.hasPayment = configResult.hasPayment;
		vwPaymentSession.loading = false;
	},
	view: ({ attrs }) => {
		const { amount, currency } = attrs;
		const formatAmount = (amount) => {
			const locale = app.locale.replace('_', '-');
			return Number(amount).toLocaleString(locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		};

		if (vwPaymentSession.loading) {
			return m(
				'div',
				{
					class: `container`,
					style: { overflow: 'hidden', display: 'grid', placeItems: 'center' },
				},
				[
					m('img', {
						src: constants.IMAGE_ECOM_PAY,
						class: 'logo',
						alt: 'Ecom Pay Logo',
						style: { width: '6rem', 'object-fit': 'contain' },
					}),
					Loading,
				]
			);
		}

		if (vwPaymentSession.hasPayment === true && vwPaymentSession.requestDuplicatePaymentPermission === false) {
			return m('div', { class: 'container' }, [
				m('div', { class: 'card' }, [
					m('div', { class: 'card__upper' }, [
						m('div', { class: 'card__upper__content' }, [
							m('h3', 'This session already has a payment.'),
							m(
								'button',
								{
									class: 'btn',
									onclick: () => {
										vwPaymentSession.requestDuplicatePaymentPermission = true;
									},
								},
								'Try again'
							),
						]),
					]),
					m('div', { class: 'card__lower' }, [
						m('div', { class: 'card__lower__content' }, [
							m('p', 'Payment by'),
							m('img', {
								src: constants.IMAGE_ECOM_PAY,
								class: 'logo',
								alt: 'Ecom Pay Logo',
								style: { height: '50px', 'object-fit': 'contain' },
							}),
						]),
					]),
				]),
			]);
		}

		return m('div', { class: 'container' }, [
			m('div', { class: 'card' }, [
				m('div', { class: 'card__decoration' }, [
					app.theme === constants.THEME_CHIRSTMAS
						? m('img', {
								src: constants.IMAGE_CHRISTMAS_GARLAND,
								alt: 'Ecom Pay Logo',
								style: { height: '60px', 'object-fit': 'contain' },
							})
						: null,
				]),
				m('div', { class: 'card__upper' }, [
					m('div', { class: 'amount-label' }, 'Amount to pay'),
					m('div', { class: 'card__upper__title' }, m.trust(constants[`CURRENCY_CODE_${currency}`] + formatAmount(amount))),
				]),
				m('div', { class: 'card__lower' }, [
					m(vwAdyenDropin),

					m('div', { class: 'or-divider' }, [m('span', 'or')]),
					m(
						'button',
						{
							class: 'btn btn--danger ',
							onclick: () => {
								paymentSession.cancelSession();
							},
						},
						'Cancel Payment'
					),
					m('div', { class: 'card__lower__content' }, [
						m('div', [
							app.theme === constants.THEME_CHIRSTMAS ? m(christmasSled) : null,
							m('div', { class: 'payment-by' }, [
								m('span', 'Payment by'),
								m('img', {
									src: constants.IMAGE_ECOM_PAY,
									alt: 'Ecom Pay Logo',
								}),
							]),
						]),
					]),
				]),
			]),
		]);
	},
};

export default vwPaymentSession;
